import { Avatar, Box, Typography } from '@mui/material';

const UserNameCell = ({ user }) => (
  <Box display="flex" alignItems="center" gap={1.5}>
    <Avatar src={user.photoUrl} sx={{ width: 32, height: 32 }} />
    <Box>
      <Typography fontWeight={500} fontSize={14}>
        {user.firstName} {user.lastName}
      </Typography>
      {user.email && (
        <Typography fontWeight={500} fontSize={12} color="secondary">
          {user.email}
        </Typography>
      )}
    </Box>
  </Box>
);

export default UserNameCell;